import { getElement, toggleVisibility } from '../utils/dom-utils';

export function toggleSidebar(): void {
  const sidebar = getElement('sidebar');
  const overlay = getElement('sidebarOverlay');
  toggleVisibility(sidebar);
  toggleVisibility(overlay);
}

export function closeSidebar(): void {
  const sidebar = getElement('sidebar');
  const overlay = getElement('sidebarOverlay');
  toggleVisibility(sidebar, false);
  toggleVisibility(overlay, false);
}

export function openSidebar(): void {
  const sidebar = getElement('sidebar');
  const overlay = getElement('sidebarOverlay');
  toggleVisibility(sidebar, true);
  toggleVisibility(overlay, true);
}

export function setupSidebar(): void {
  const overlay = getElement('sidebarOverlay');
  const closeBtn = document.querySelector('.sidebar-close');

  if (overlay) {
    overlay.addEventListener('click', closeSidebar);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeSidebar);
  }
}
